import { useEffect, useRef } from "react";
import moment from "moment";

const ChatBody = ({ ticketChat, id, SingleResolution }) => {
  const scrollDown = useRef(null);

  useEffect(() => {
    scrollDown.current.scrollTop = scrollDown.current.scrollHeight;
  }, [ticketChat]);

  return (
    <>
      <div
        className="chat-container bg-white rounded-bottom rounded-lg"
        ref={scrollDown}
      >
        <div>
          <div>
            {ticketChat?.map((item, idx) => {
              const isSender = item?.senderId === id;
              const sideClass = item?.senderId === id ? "right" : "left";

              return (
                <div className={`d-flex ${sideClass} mt-3`} key={idx}>
                  {isSender ? (
                    <h5 className="mx-1 mb-1">
                      {SingleResolution?.data?.name}
                    </h5>
                  ) : (
                    <>
                      <h5 className="mx-1 mb-1">Admin</h5>
                    </>
                  )}
                  <div className={`message-bubble-${sideClass}`}></div>
                  <div
                    className={`message ${
                      isSender ? "message-right" : "message-left"
                    }`}
                  >
                    {item?.message}

                    <div className={`d-flex ${sideClass}`}>
                      <div className="d-flex justify-content-end m-2">
                        <small className="mb-0">
                          {item
                            ? moment
                                .unix(item?.createdAt?.seconds)
                                .format("MMMM Do YYYY, h:mm:ss")
                            : "N/A"}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatBody;
